import { State } from './types';

const getters = {
  getUserGroupToken: (state: State) => {
    return state.userGroupToken;
  },
  getLoadingState: (state: State) => {
    return state.loading;
  },
  getExploError: (state: State) => {
    return state.exploError;
  }
};

export default getters;
